<script>
    import {mapStore} from '@js/stores/mapStore';

    import {viewport} from '@js/components/themes/actions/viewport';

    import MapElevationGraph from '@js/components/maps/MapElevationGraph.svelte';

    const {
        rideId
    } = $props();

    let isShowElevation = $state(false);

    const _onViewportEnter = () => {
        isShowElevation = true;
    };
</script>

<div use:viewport
     onviewportEnter={_onViewportEnter}>
    {#if isShowElevation && $mapStore.map}
        <MapElevationGraph map={$mapStore.map}
                           hasDefaultClass={false}
                           rideId={rideId}
                           warningHelper={true}/>
    {/if}
</div>
